export default __webpack_public_path__ + "static/screen-implementation-03ad103a070ca54bf3754246dae85490.png";